import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const CropRotateIcon = ({
    color = 'currentColor',
    size = 24,
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            fill={color}
            d="m11.908 11.218-.454.891zm.874.874-.891.454zM2 10a1 1 0 1 0 0 2v-2m10 12a1 1 0 1 0 2 0h-2m4-2a1 1 0 1 0 0-2v2m-7.8-1v1zM5 15.8H4zM6 8a1 1 0 1 0-2 0h2m.092 10.782.454-.891zm-.874-.874.891-.454zM20 12a1 1 0 1 0 2 0h-2m-7-8-.707-.707a1 1 0 0 0 0 1.414zm3.207-1.793A1 1 0 0 0 14.793.793l.707.707zm-1.414 5a1 1 0 1 0 1.414-1.414L15.5 6.5zM5 11v1h4.8v-2H5zm8 3.2h-1V19h2v-4.8zM9.8 11v1c.577 0 .949 0 1.232.024.272.022.373.06.422.085l.454-.891.454-.891c-.378-.193-.772-.264-1.167-.296C10.811 9.999 10.344 10 9.8 10zm3.2 3.2h1c0-.544 0-1.011-.03-1.395-.033-.395-.104-.789-.297-1.167l-.891.454-.891.454c.025.05.063.15.085.422.023.283.024.655.024 1.232zm-1.092-2.982-.454.891a1 1 0 0 1 .437.437l.891-.454.891-.454a3 3 0 0 0-1.311-1.311zM2 11v1h3v-2H2zm11 8h-1v3h2v-3zm3 0v-1h-3v2h3zm-3 0v-1H8.2v2H13zm-8-3.2h1V11H4v4.8zM5 11h1V8H4v3zm3.2 8v-1c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085l-.454.891-.454.891c.378.193.772.264 1.167.296.384.032.851.031 1.395.031zM5 15.8H4c0 .544 0 1.011.03 1.395.033.395.104.789.297 1.167l.891-.454.891-.454c-.025-.05-.063-.15-.085-.422C6 16.75 6 16.377 6 15.8zm1.092 2.982.454-.891a1 1 0 0 1-.437-.437l-.891.454-.891.454a3 3 0 0 0 1.311 1.311zM21 12h1V8h-2v4zm-4-8V3h-4v2h4zm-1.5-2.5-.707-.707-2.5 2.5L13 4l.707.707 2.5-2.5zM13 4l-.707.707 2.5 2.5.707-.707.707-.707-2.5-2.5zm8 4h1a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3z"
        />
    </svg>
);
export { CropRotateIcon };
